import {UI} from "../../../../../../stem-core/ui/UIBase";

import {styleRule, StyleSheet} from "../../../../../../stem-core/ui/Style";
import {registerStyle} from "../../../../../../stem-core/ui/style/Theme";
import {CircleCheckIcon} from "../../../../../../core/ui/SVGElements.jsx";
import {SubscriptionCoverage} from "../../../../../../client/state/SubscriptionCoverageStore";


class SubscriptionCoveragePerkStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "center",
        color: this.themeProps.TEXT_SECONDARY_COLOR,
    };

    @styleRule
    checkIcon = {
        marginRight: 12,
        alignSelf: "normal",
    };
}

@registerStyle(SubscriptionCoveragePerkStyle)
export class SubscriptionCoveragePerk extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            text: null
        }
    }

    render() {
        return [
            <CircleCheckIcon className={this.styleSheet.checkIcon}/>,
            <div>{this.options.text}</div>
        ];
    }
}

class SubscriptionCoverageTitleStyle extends StyleSheet {
    @styleRule
    container = {
        fontSize: this.themeProps.FONT_SIZE_LARGE,
        fontWeight: this.themeProps.FONT_WEIGHT_BOLD,
        margin: "auto",
        width: "fit-content",
    }
}

// The title of another subscription coverage when listing as a sub-perk
@registerStyle(SubscriptionCoverageTitleStyle)
export class SubscriptionCoverageTitle extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            coverageId: null,
        }
    }

    render() {
        const {coverageId} = this.options;
        const subscriptionCoverage = SubscriptionCoverage.get(coverageId);

        return subscriptionCoverage?.getName();
    }
}
